import axios from '../../axios/index';

export default {

    getSettings () {
        return axios.get('/api/v1/shop-drawings/priority-settings');
    },
    getSetting (id) {
        return axios.get('/api/v1/shop-drawings/priority-settings/' + id);
    },
    getSettingTypeOptions () {
        return axios.get('/api/v1/shop-drawings/priority-settings/types');
    },
    createSetting (data) {
        let formData = new FormData();
        formData.append('name', data['name']);
        formData.append('type', data['type']);
        formData.append('sort_id', data['sort_id'] || null);
        return axios.post('/api/v1/shop-drawings/priority-settings', formData);
    },
    updateSetting (id, data) {
        let formData = new FormData();
        formData.append('name', data['name']);
        formData.append('type', data['type']);
        return axios.post('/api/v1/shop-drawings/priority-settings/' + id, formData);
    },
    setDisabled (settingId, value) {
        let formData = new FormData();
        formData.append('value', value);
        return axios.post('/api/v1/shop-drawings/priority-settings/' + settingId + '/disabled', formData);
    },
    getLogs () {
        return axios.get('/api/v1/shop-drawings/priority-settings/changelog');
    },
    updateSort(formData) {
        return axios.post('/api/v1/shop-drawings/priority-settings/sort-settings', formData);
    }
};
